import React, {
  useEffect, useRef, useCallback, forwardRef, useImperativeHandle,
} from 'react';

import { EditTwoTone, DeleteTwoTone } from '@ant-design/icons';
import { Space, Tooltip } from 'antd';

import useManager from '../../../hooks/manager';
import api from '../../../services/api';
import Table from '../../Table';
import ColumnSearch from '../../Table/Filter';
import { Action } from '../../Table/styles';
import UpdateForm from '../UpdateForm';

const ProductTable = forwardRef(({ appIntegrationId }, ref) => {
  const updateRef = useRef();
  const {
    loading, datas, destroy, setDatas,
  } = useManager();

  const loadProducts = useCallback(async () => {
    if (appIntegrationId) {
      try {
        const { data } = await api.get(`/product/appintegration/${appIntegrationId}`);
        setDatas(data);
      } catch (err) {
        console.error('Failed to load products', err);
        setDatas([]);
      }
    } else {
      setDatas([]);
    }
  }, [appIntegrationId, setDatas]);

  useEffect(() => {
    loadProducts();
  }, [loadProducts]);

  useImperativeHandle(ref, () => ({
    reload: loadProducts,
  }));

  const columns = [
    {
      title: 'Código Nome do Produto',
      dataIndex: 'slug',
      key: 'slug',
      ellipsis: true,
      filterMultiple: false,
      ...ColumnSearch('Slug', 'slug'),
    },
    {
      title: 'Nome',
      dataIndex: 'name',
      key: 'name',
      sorter: (a, b) => a.name.localeCompare(b.name),
      sortDirections: ['descend', 'ascend'],
      ellipsis: true,
      filterMultiple: false,
      ...ColumnSearch('Nome', 'name'),
    },
    {
      title: 'Descrição',
      dataIndex: 'description',
      key: 'description',
      ellipsis: true,
      filterMultiple: false,
      ...ColumnSearch('Descrição', 'description'),
    },
    {
      title: 'App de Integração',
      dataIndex: ['appIntegration', 'name'],
      key: 'appIntegration',
      ellipsis: true,
    },
  ];

  return (
    <>
      <UpdateForm ref={updateRef} onSuccess={loadProducts} />
      <Table
        data={datas}
        loading={loading}
        columns={columns}
        actions={{
          title: 'Ações',
          key: 'action',
          width: 100,
          align: 'center',
          render: (text, record) => (
            <Space size="middle">
              <Tooltip placement="top" title="Alterar">
                <Action onClick={() => updateRef.current.open(record.id || record._id)}>
                  <EditTwoTone />
                </Action>
              </Tooltip>
              <Tooltip placement="top" title="Excluir">
                <Action onClick={() => destroy(record.id || record._id, '/product', loadProducts)}>
                  <DeleteTwoTone twoToneColor="#f00" />
                </Action>
              </Tooltip>
            </Space>
          ),
        }}
      />
    </>
  );
});

export default ProductTable;
